<template>
  <div v-if="visibleBadgeSlots.length > 0" class="product-badges">
    <component
      :is="slotHref(slot) ? 'a' : 'span'"
      v-for="slot in visibleBadgeSlots"
      :key="slot"
      :href="slotHref(slot)"
      v-bind="slotHref(slot) ? badgeLinkAttrs : {}"
      class="badge"
      :class="slotClasses(slot)"
      :style="slotStyle(slot)"
    >
      {{ slotLabel(slot) }}
    </component>
  </div>
</template>

<script>
import { isDefined } from "ceres/app/helper/utils";
import {
  resolveBadgeSlots,
  selectBadgeTags,
  parseBadgeTagIds,
  badgeTagStyle,
  badgeTagHref,
  badgeTagLinkAttrs,
  badgeTagUrlOptions,
} from "~/app/helper/badgeSlots";

export default {
  name: "item-store-special",

  props: [
    "tags",
    "hasCrossPrice",
    "recommendedRetailPrice",
    "variationRetailPrice",
    "specialOfferPrice",
    "decimalCount",
    "categoryDiscountLabel",
  ],

  computed: {
    tagList() {
      return selectBadgeTags(this.tags, parseBadgeTagIds(App.badgeTagIds));
    },

    badgeSlots() {
      const tagIds = this.tagList.map((tag) => tag.id);

      return resolveBadgeSlots(
        tagIds,
        this.hasCrossPrice,
        !!this.categoryDiscountLabel
      );
    },

    badgeLinkAttrs() {
      return badgeTagLinkAttrs(App.badgeTagLinkTarget);
    },

    visibleBadgeSlots() {
      return this.badgeSlots.filter((slot) => this.slotLabel(slot) !== "");
    },
  },

  methods: {
    isDiscountSlot(slot) {
      return slot === "discount";
    },

    isCategoryDiscountSlot(slot) {
      return slot === "category-discount";
    },

    findTag(tagId) {
      return this.tagList.find((tag) => tag.id === tagId);
    },

    slotClasses(slot) {
      if (this.isDiscountSlot(slot)) {
        return "badge-offer badge-danger";
      }

      return this.isCategoryDiscountSlot(slot) ? "badge-category-discount" : "";
    },

    slotHref(slot) {
      if (this.isDiscountSlot(slot) || this.isCategoryDiscountSlot(slot)) {
        return null;
      }

      return badgeTagHref(
        this.findTag(slot),
        App.badgeTagLinks,
        App.badgeTagLinkScope,
        "category",
        badgeTagUrlOptions()
      );
    },

    slotLabel(slot) {
      if (this.isDiscountSlot(slot)) {
        return this.getPercentageSale();
      }

      if (this.isCategoryDiscountSlot(slot)) {
        return this.categoryDiscountLabel || "";
      }

      const tag = this.findTag(slot);

      return tag && tag.names && tag.names.name ? tag.names.name : "";
    },

    slotStyle(slot) {
      if (this.isDiscountSlot(slot) || this.isCategoryDiscountSlot(slot)) {
        return {};
      }

      return badgeTagStyle(this.findTag(slot));
    },

    getPercentageSale() {
      let percent;

      if (isDefined(this.specialOfferPrice)) {
        percent =
          (1 -
            this.specialOfferPrice.unitPrice.value /
              this.variationRetailPrice.unitPrice.value) *
          -100;
      } else if (isDefined(this.recommendedRetailPrice)) {
        percent =
          (1 -
            this.variationRetailPrice.unitPrice.value /
              this.recommendedRetailPrice.unitPrice.value) *
          -100;
      }

      if (percent < 0) {
        return (
          percent
            .toFixed(this.decimalCount)
            .replace(".", App.decimalSeparator) + "%"
        );
      }

      return "";
    },
  },
};
</script>
